import baseTime from '@/__vue2stone/service/wasa/time';
import moment from 'moment';

export default {
  getTimeFormat(date, format) {
    return baseTime.getTimeFormat(date, format);
  },
  getDateMonth(date) {
    return moment(date).format('M');
  },
  getSeasonStartDate(date, currentMonth, season) {
    const num = season.indexOf(parseInt(currentMonth));
    const _date = moment(date)
      .startOf('month')
      .subtract(num, 'months');
    return _date;
  },
};
